import {
  makeSkillWebCompaniesRedirectUrl,
  makeSkillWebInstitutionsRedirectUrl,
  makeSkillWebManagerUsersRedirectUrl,
  makeSkillWebRequestsRedirectUrl
} from '@/main/factories/http'
import PathConstants from '@/main/routes/paths'
import theme from '@assets/styles/theme'
import { Box, Container, Tabs } from '@mui/material'
import { TabApp } from '@presentation/components/ui/navigation/tab/tab-app'
import { SyntheticEvent, useEffect, useState } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { AnalyticsEventName } from '@/infra/tracking/analytics-event-names'
import { AnalyticsTracker } from '@/infra/tracking'

export function DesktopNavMenuInternalCompanyManager() {
  const { INTERNAL_COMPANY_MANAGER_USER_BATCH_DISABLE, INTERNAL_COMPANY_MANAGER_INVOICE } =
    PathConstants.Routes
  const location = useLocation()
  const [tabSelectedValue, setTabSelectedValue] = useState<string | false>(false)

  const handleTabClick = (_: SyntheticEvent, newValue: string | false) => {
    AnalyticsTracker.trackEvent(AnalyticsEventName.HEADER_NAV_MENU, {
      open: newValue
    })
  }

  const identifyLocation = (): string | false => {
    const routes = [INTERNAL_COMPANY_MANAGER_USER_BATCH_DISABLE, INTERNAL_COMPANY_MANAGER_INVOICE]
    return routes.find(route => route.value === location.pathname)?.name ?? false
  }

  useEffect(() => {
    const locationValue = identifyLocation()
    setTabSelectedValue(locationValue)
  }, [location])

  const tabsSx = {
    minHeight: theme.spacing(8),
    height: theme.spacing(8)
  }

  return (
    <Container maxWidth="lg" disableGutters>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}
      >
        <Tabs
          value={tabSelectedValue}
          onChange={handleTabClick}
          variant="scrollable"
          allowScrollButtonsMobile
          sx={{
            height: theme.spacing('auto')
          }}
        >
          <TabApp
            component={Link}
            to={makeSkillWebManagerUsersRedirectUrl()}
            label={INTERNAL_COMPANY_MANAGER_USER_BATCH_DISABLE.title}
            value={INTERNAL_COMPANY_MANAGER_USER_BATCH_DISABLE.name}
            selectedValue={tabSelectedValue}
            sx={tabsSx}
          />

          <TabApp
            component={Link}
            to={makeSkillWebRequestsRedirectUrl()}
            label="Pedidos"
            value="Orders"
            selectedValue={tabSelectedValue}
            sx={tabsSx}
          />

          <TabApp
            component={Link}
            to={INTERNAL_COMPANY_MANAGER_INVOICE.value}
            label={INTERNAL_COMPANY_MANAGER_INVOICE.title}
            value={INTERNAL_COMPANY_MANAGER_INVOICE.name}
            selectedValue={tabSelectedValue}
            sx={tabsSx}
          />

          <TabApp
            component={Link}
            to={makeSkillWebInstitutionsRedirectUrl()}
            label="Parcerias"
            value="Institutions"
            selectedValue={tabSelectedValue}
            sx={tabsSx}
          />

          <TabApp
            component={Link}
            to={makeSkillWebCompaniesRedirectUrl()}
            label="Empresas"
            value="Companies"
            selectedValue={tabSelectedValue}
            sx={tabsSx}
          />
        </Tabs>
      </Box>
    </Container>
  )
}
